import React, { FC } from 'react'
import styled from 'styled-components/macro'

import { ReactComponent as Fail } from '../../../assets/fail.svg'
import { ReactComponent as ContractTable } from '../../../assets/contract-table.svg'

const icons = {
  fail: Fail,
  contractTable: ContractTable,
}

export type SupportedIcons = typeof icons

export type SupportedSizes = {
  sm: number
  md: number
  lg: number
}

const sizeTable: SupportedSizes = {
  sm: 14,
  md: 20,
  lg: 135,
}

export interface IconProps {
  name: keyof SupportedIcons
  size?: keyof SupportedSizes
}

export interface SpanProps {
  size: keyof SupportedSizes
  customSize?: string
}

const Icon: FC<IconProps> = ({ name, size = 'sm' }) => {
  const IconComponent = icons[name]
  return (
    <Wrapper className={`${name}`} {...{ size }}>
      <IconComponent />
    </Wrapper>
  )
}

const Wrapper = styled.span<SpanProps>`
  svg {
    height: ${(p) => p.customSize || `${sizeTable[p.size]}px`};
    width: auto;
  }

  &.fail {
    margin-right: 0.2rem;
    vertical-align: middle;
  }

  &.contractTable {
    margin-right: 0.2rem;
    vertical-align: middle;
  }
`

export default Icon
